import styled from 'styled-components';

export const IndexCell = styled.span`
  font-weight: bold;
  color: #666;
`;

export const MonospaceCell = styled.span`
  font-family: monospace;
  font-size: 13px;
  color: #333;
`;

export const PatternArrow = styled.span`
  font-size: 12px;
  color: #999;
  margin: 0 4px;
  font-weight: bold;
`;

export const PatternContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
`;

export const PatternEvent = styled.span`
  font-size: 12px;
  color: #333;
  font-weight: 500;
  padding: 2px 4px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
`;
